import { Component, Input, OnInit } from '@angular/core';
import { rejects } from 'assert';
import { resolve } from 'dns';
import { ApiService } from 'src/app/Services/api.service';
import { MapService } from 'src/app/Services/map.service';
import { RouteService } from 'src/app/Services/route.service';
import { SharedService } from 'src/app/Services/shared.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

declare var google: any;

@Component({
  selector: 'g10-dashboard-route-exploration',
  templateUrl: './route-exploration.component.html',
  styleUrls: ['./route-exploration.component.css']
})
export class RouteExplorationComponent implements OnInit {

  @Input() selectedRoutes(val: string) {
    if (val !== undefined && Object.keys(val).length > 0 && this.routeExplorationMap != undefined) this.reloadMap();
    else this.loadMap();
  }

  public routeExplorationMap: any;
  public currentLocationVehicles: any = [];
  public selectedRouteDetails = [];
  public vehicles: any = [];
  public map:any;

  //for map
  public selectedMap:string='openStreetMap';
  // public selectedMap:string='google';
  public googleMapObj:any;
  constructor(
    public mapService: MapService,
    public api: ApiService,
    private swal: SweetAlert,
    private routeservice: RouteService,
    private share: SharedService,
    public storage: StorageService,
  ) {
    this.map =  this.mapService.retMap()['mymap'];
    this.share._subject.subscribe((data: any) => {
      // console.log(data,'service data');
      if(this.selectedMap != 'google'){
        if (data.type == 'socketData') {
          this.getVehicleList(data.data,'Socket');
          // data.data.map((item) => {
          //   // if (item.imei == '861359038057954')
          //   //   console.log(item.imei, item.lat, item.lng, item);
  
          //   const color = item.speed > 5 ? 'green-dot' : 'red-dot';
          //   const marker = {
          //     id: '_Route_Exploration_'+item.reg,
          //     content: `<div class="${color} dot--basic" ></div>`,
          //     lat: parseFloat(item.lat),
          //     lng: parseFloat(item.lng),
          //     // lat: 12.987315434653826,
          //     // lng: 80.22082852957499,
          //     bearing: true,
          //     popup: { content: item.near, open: false },
          //     cluster: '_Route_Exploration_'
          //   };
          //   // if (this.map != undefined) this.map.marker(marker);
          //   // markers.push(marker);
          //   // console.log('marker ', marker)
            
          //   // }
          // });
        }
      }
      })
  }

  ngOnInit(): void {
    let user= this.storage.get('userInfo');
    if(user && user.map){
      this.selectedMap = user.map;
    }
    
    this.loadMap();
    if(this.selectedMap != 'google'){
      // setTimeout(()=>{ this.getCurrentLocationVeh(); },500) 
    }
  }
  getCurrentLocationVeh() {
    this.api.getCurrentLocation({}).then((res: any) => {
      this.currentLocationVehicles = res.data;
      this.getVehicleList(res.data);
      // else this.currentLocationVehicles=[];
    })
  }
  getVehicles(routes: any) {
    return new Promise((resolve, rejects) => {
      let vehicleList = [];
      routes.map((item: any, i: number) => {
        vehicleList = [...vehicleList, ...item.vehicle];
        if (routes.length - 1 == i) resolve(vehicleList);
      });

    })
  }
  async getVehicleList(vehicles: any,type='N') {
    // console.log(this.selectedRoutes);
    // return new Promise((resolve,rejects)=>{
    // if (this.vehicles.length <= 0) 
    this.vehicles = await this.getVehicles(this.selectedRoutes);
    let markers = []; 

    vehicles.map((veh: any, i: number) => {
      let vehicle = (typeof veh == 'string') ? JSON.parse(veh) : veh;
      if (this.vehicles.indexOf(vehicle['reg']) !== -1) {
        const color = vehicle['spd'] > 5 ? 'green-dot' : 'red-dot';
        markers.push({
          id: '_Route_Exploration_' + vehicle['reg'],//regNo,
          content: `<div class="${color} dot--basic"></div>
            <span class="mumb_marker_marker-label" style="visibility: visible;">${vehicle['reg'].toUpperCase()}</span>`,
          lat: parseFloat(vehicle['lat']),
          lng: parseFloat(vehicle['lng']),
          cluster: '_Route_Exploration_',
          bearing: true,
        });
      }
      if (vehicles.length - 1 == i) {
        // console.log('markers ', markers,this.routeExplorationMap)
        this.reloadMap();
        this.routeExplorationMap.clusters = [
          {
            name: '_Route_Exploration_',  // unique id
            maxZoom: 10, // max zoom on cluster click event
            radius: 20,
            color: 'rgba(255, 0, 0, 0.2)', // '#be9694'  // for opacity use rgb
            textColor: 'green' // count color
          }];
        this.routeExplorationMap.addMarkers(markers);
          setTimeout(() => {
            this.routeExplorationMap.clusterSynch();
          }, 500);
          const parent = this;
          this.routeExplorationMap.onMapZoom(function (z) {
            parent.routeExplorationMap.clusterSynch();
            setTimeout(() => { parent.routeExplorationMap.marker(markers); }, 10);
          });
        // let map = this.mapService.retMap();//clusterSycn('routeExplorationMap');
        // if (type=='N') this.mapService.addMarker('routeExplorationMap', markers);
        // else if(type=='Socket') map.mymap.marker(markers);
        // 
        // setTimeout(() => {
        //   map.mymap.clusterSycn();
        // }, 500)
      }
    });
    // if (routes.length - 1 == i) { //selectedRouteDetails
    //   this.currentLocationVehicles.map((veh: any) => {
    //     let vehicle = JSON.parse(veh);
    //     if (vehicleList.indexOf(vehicle['reg']) !== -1) {
    //       const color = vehicle['spd'] > 5 ? 'green-dot' : 'red-dot';
    //       markers.push({
    //         id: '_Route_Exploration_' + vehicle['reg'],//regNo,
    //         content: `<div class="${color} dot--basic"></div>
    //         <span class="mumb_marker_marker-label" style="visibility: visible;">${vehicle['reg'].toUpperCase()}</span>`,
    //         lat: parseFloat(vehicle['lat']),
    //         lng: parseFloat(vehicle['lng']),
    //         cluster: '_Route_Exploration_',
    //         bearing: true,
    //       });
    //     }
    //     //  if(veh['reg']==item[''])
    //   });
    //   // console.log('Markerss ', markers)
    //   this.mapService.addMarker('routeExplorationMap', markers);
    //   let map = this.mapService.retMap();//clusterSycn('routeExplorationMap');

    //   setTimeout(() => {
    //     map.mymap.clusterSycn();
    //   }, 500)
    //   // this.routeExplorationMap.addMarkers(markers);
    //   // setTimeout(() => {
    //   //   this.routeExplorationMap.clusterSynch();
    //   // }, 500);
    //   // console.log('vehicleList ', vehicleList, 'this.currentLocationVehicles--->>> ', this.currentLocationVehicles)
    // }
    // })
    // })


  }
  loadMap() {
    if(this.selectedMap=='google'){
      setTimeout(()=>{
        const mapOptions = {
          scrollwheel: true,
          zoom: 5,
          maxZoom: 17,
          center: new google.maps.LatLng(20.5937, 78.9629),
          disableDefaultUI: false
        };
        this.googleMapObj = new google.maps.Map(document.getElementById('routeExplorationMap'), mapOptions);
      },1000)
    }else{
      this.mapService.map("routeExplorationMap").then((map) => {
        this.routeExplorationMap = map;
        // console.log('map initial',this.routeExplorationMap);
        setTimeout(() => { this.reloadMap(); }, 100);
      }).catch((error) => {
        console.log('routeExplorationMap', error);
      });
    }
  }

  reloadMap() {
    if(this.selectedMap != 'google'){
      this.routeExplorationMap.removeMarkerAll();
      this.routeExplorationMap.removeLineAll();
    }
  }

}
